import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface showWorkIdI {
  id: string
}

const initialState: showWorkIdI = {
  id: ''
}

export const setShowWorkIdSlice = createSlice({
  name: 'setShowWorkId',
  initialState,
  reducers: {
    setShowWorkId: (state, action: PayloadAction<string>) => {
      state.id = action.payload
    }
  }
})
export const { setShowWorkId } = setShowWorkIdSlice.actions
export default setShowWorkIdSlice.reducer
